angular.module('core')
    .directive('emailInput', function () {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                inputId: '@?',
                inputName: '@?',
                required: '<?',
                disabled: '<?',
                placeholder: '@?'
            },
            bindToController: true,
            controllerAs: '$ctrl',
            templateUrl: 'app/utils/email-input/email-input.html',
            controller: function () {
                this.$onInit = () => {
                    this.required = this.required === true
                    this.disabled = this.disabled === true
                }

                this.normalizeValue = value => {
                    if (value === null || value === undefined) {
                        return null
                    }

                    let normalized = String(value).trim()
                    return normalized ? normalized : null
                }

                this.commit = () => {
                    if (!this.ngModelCtrl) {
                        return
                    }

                    this.ngModelCtrl.$setViewValue(this.normalizeValue(this.value))
                    this.runNgChange()
                }
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                let ctrl = scope.$ctrl
                ctrl.ngModelCtrl = ngModelCtrl
                ctrl.runNgChange = () => {
                    if (attrs.ngChange) {
                        scope.$parent.$evalAsync(attrs.ngChange)
                    }
                }

                ngModelCtrl.$render = function () {
                    ctrl.value = ngModelCtrl.$viewValue || ''
                }
            }
        }
    })
